module.exports = __webpack_public_path__ + "static/img/3-aftersale-issue-registration.d84f1fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-aftersale-issue-registration.png
// module id = 1329
// module chunks = 0